import moment from "moment";
import { cleanDateFormat } from "./cleanDateFormat";

export const renderDate = date => {
  if (!date) {
    return "";
  }
  return date.length > 10
    ? moment(cleanDateFormat(date)).format("MMM DD, YYYY")
    : moment(date).format("MMM DD, YYYY");
};
